module.exports = __webpack_public_path__ + "img/img-13.84f2067c.png";